export default __webpack_public_path__ + "static/media/1.1119b583.png";